"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "../Drawer/Drawer.variants.js";
import { dialogVariants } from "./Dialog.variants.js";
import { useDialogMode } from "./DialogContext.js";
const { backdrop: dialogBackdrop } = dialogVariants();
const { backdrop: drawerBackdrop } = drawerVariants();
const DialogBackdrop_DialogBackdrop = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const mode = useDialogMode();
    const classes = cn('drawer' === mode ? drawerBackdrop() : dialogBackdrop(), className, slots?.backdrop);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Backdrop, {
        ref: ref,
        className: classes,
        ...props
    });
    return /*#__PURE__*/ jsx(Dialog.Backdrop, {
        ref: ref,
        className: classes,
        ...props,
        forceRender: true
    });
});
export { DialogBackdrop_DialogBackdrop as DialogBackdrop };
